<template>
  <div>
    <!-- PC端 Header -->
    <div class="header pc-header">
      <div class="logo_box">
        <div class="logo">
          <router-link to="/">
            <img :src="logoUrl" alt="logo" />
          </router-link>
        </div>
        <div class="nav">
          <ul class="top_nav">
            <li :class="{ on: act === 'index' }">
              <router-link to="/">首页</router-link>
            </li>
            <li :class="{ on: act === 'jcpt' }">
              <router-link to="/jcpt">检测平台</router-link>
            </li>
            <li :class="{ on: act === 'yqyy' }">
              <router-link to="/yqyy">仪器预约</router-link>
            </li>
            <li :class="{ on: act === 'wtjc' }">
              <router-link to="/wtjc">委托检测</router-link>
            </li>
            <li :class="{ on: act === 'feedback' }">
              <router-link to="/feedback">意见反馈</router-link>
            </li>
            <li :class="{ on: act === 'zxjj' }" class="has-sub">
              <router-link to="/zxjj">机构概况</router-link>
              <ul class="sj_xia">
                <li><router-link to="/zxjj?id=1">中心简介</router-link></li>
                <li><router-link to="/zxjj?id=3">中心资质</router-link></li>
                <li><router-link to="/zxjj?id=4">中心成员</router-link></li>
              </ul>
            </li>
            <li :class="{ on: act === 'news' }" class="has-sub">
              <router-link to="/news">新闻中心</router-link>
              <ul class="sj_xia">
                <li><router-link to="/news?id=1">新闻资讯</router-link></li>
                <li><router-link to="/news?id=2">通知公告</router-link></li>
                <li><router-link to="/news?id=4">培训通知</router-link></li>
                <li><router-link to="/news?id=3">学术动态</router-link></li>
              </ul>
            </li>
            <li :class="{ on: act === 'xxgk' }">
              <router-link to="/xxgk">信息公开</router-link>
            </li>
            <li :class="{ on: act === 'about' }">
              <router-link to="/about">关于我们</router-link>
            </li>
            <li>
              <a href="http://www.icost.ac.cn/" target="_blank">院网站</a>
            </li>
          </ul>
        </div>

        <!-- 搜索框 -->
        <div class="search">
          <el-input
            v-model="searchKeyword"
            placeholder="请输入关键词"
            class="search_input"
            @keyup.enter.native="doSearch"
          >
            <i slot="prefix" class="el-input__icon el-icon-search" />
          </el-input>
          <el-button type="primary" class="search_btn" @click="doSearch">搜索</el-button>
        </div>

        <!-- 登录/用户信息 -->
        <div class="dl_zc">
          <template v-if="isLogin">
            <el-dropdown trigger="hover" @command="handleUserCommand">
              <span class="el-dropdown-link user-link">
                <el-avatar class="user-avatar" :size="32" :src="avatarSrc" icon="el-icon-user-solid" />
                <span class="user-name">{{ customerName }}</span>
                <el-badge :value="messageCount" :hidden="messageCount <= 0" :max="99" class="msg-badge" />
                <i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="grxx">
                  个人中心
                  <el-badge :value="messageCount" :hidden="messageCount <= 0" :max="99" />
                </el-dropdown-item>
                <!-- <el-dropdown-item command="xxtz">查看全部信息</el-dropdown-item> -->
                <el-dropdown-item divided command="logout">退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template v-else>
            <a @click="goLogin">登录</a>
            <span class="divider">|</span>
            <router-link to="/register">注册</router-link>
          </template>
        </div>
        <div class="clear" />
      </div>
    </div>

    <!-- 移动端 Header -->
    <div class="mobile-header">
      <div class="xin_logo">
        <router-link to="/">
          <img :src="logoUrl" alt="logo" />
        </router-link>
      </div>
      <div class="nav-btn" :class="{ active: mobileMenuOpen }" @click="toggleMobileMenu">
        <span /><span /><span />
      </div>
      <div v-show="mobileMenuOpen" class="mobile-nav">
        <ul>
          <li><router-link to="/" @click.native="closeMobileMenu">首页</router-link></li>
          <li><router-link to="/jcpt" @click.native="closeMobileMenu">检测平台</router-link></li>
          <li><router-link to="/yqyy" @click.native="closeMobileMenu">仪器预约</router-link></li>
          <li><router-link to="/wtjc" @click.native="closeMobileMenu">委托检测</router-link></li>
          <li>
            <router-link to="/zxjj" @click.native="closeMobileMenu">机构概况</router-link>
            <i class="el-icon-arrow-down" @click="toggleSubMenu($event, 'zxjj')" />
            <div v-show="subMenuOpen.zxjj" class="sub-nav">
              <router-link to="/zxjj?id=1" @click.native="closeMobileMenu">中心简介</router-link>
              <router-link to="/zxjj?id=3" @click.native="closeMobileMenu">中心资质</router-link>
              <router-link to="/zxjj?id=4" @click.native="closeMobileMenu">中心成员</router-link>
            </div>
          </li>
          <li>
            <router-link to="/news" @click.native="closeMobileMenu">新闻中心</router-link>
            <i class="el-icon-arrow-down" @click="toggleSubMenu($event, 'news')" />
            <div v-show="subMenuOpen.news" class="sub-nav">
              <router-link to="/news?id=1" @click.native="closeMobileMenu">新闻资讯</router-link>
              <router-link to="/news?id=2" @click.native="closeMobileMenu">通知公告</router-link>
              <router-link to="/news?id=4" @click.native="closeMobileMenu">培训通知</router-link>
            </div>
          </li>
          <li><router-link to="/xxgk" @click.native="closeMobileMenu">信息公开</router-link></li>
          <li><router-link to="/about" @click.native="closeMobileMenu">关于我们</router-link></li>
          <li><a href="http://www.icost.ac.cn/" target="_blank">院网站</a></li>
          <template v-if="isLogin">
            <li><router-link to="/user/grxx" @click.native="closeMobileMenu">用户中心</router-link></li>
            <li><a @click="doLogout">退出</a></li>
          </template>
          <template v-else>
            <li><a @click="goLogin">登录</a></li>
            <li><router-link to="/register" @click.native="closeMobileMenu">注册</router-link></li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import logoUrl from '@/assets/img/logo.png'
import { getAvatarUrl } from '@/utils/auth'

export default {
  name: 'HeaderComp',
  data () {
    return {
      logoUrl,
      searchKeyword: '',
      mobileMenuOpen: false,
      subMenuOpen: {
        zxjj: false,
        news: false
      }
    }
  },
  computed: {
    ...mapGetters(['isLogin', 'customer', 'customerName', 'messageCount']),
    avatarSrc () {
      return this.customer && this.customer.avatar ? getAvatarUrl(this.customer.avatar) : ''
    },
    act () {
      return (this.$route.meta && this.$route.meta.act) || ''
    }
  },
  mounted () {
    // 登录后获取未读消息数
    if (this.isLogin) {
      this.$store.dispatch('fetchMessageCount')
    }
  },
  methods: {
    doSearch () {
      if (!this.searchKeyword.trim()) return
      this.$router.push({ path: '/search', query: { newsTitle: this.searchKeyword } })
    },
    goLogin () {
      if (this.$route.path === '/login') return
      // 保存当前页面路径，登录后返回（排除登录/注册/找回密码等认证页）
      const authPaths = ['/login', '/register', '/find-password']
      if (!authPaths.includes(this.$route.path)) {
        sessionStorage.setItem('returnUrl', this.$route.fullPath)
      }
      this.$router.push('/login')
    },
    handleUserCommand (command) {
      if (command === 'logout') {
        this.doLogout()
      } else if (command === 'grxx') {
        this.$router.push('/user/grxx')
      } else if (command === 'xxtz') {
        this.$router.push('/user/xxtz')
      }
    },
    doLogout () {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('logout').finally(() => {
          this.$message.success('已退出登录')
          if (this.$route.path === '/login') return
          this.$router.push('/login')
        })
      }).catch(() => {})
    },
    toggleMobileMenu () {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },
    closeMobileMenu () {
      this.mobileMenuOpen = false
    },
    toggleSubMenu (e, key) {
      e.preventDefault()
      this.subMenuOpen[key] = !this.subMenuOpen[key]
    }
  }
}
</script>

<style lang="scss" scoped>
/* PC端导航 */
.pc-header {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1000;

  .logo_box {
    max-width: 1580px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    padding: 0 24px;
    height: 98px;
    min-width: 0;
  }

  .logo {
    flex-shrink: 0;
    img {
      width: 254px;
      height: 71px;
    }
  }

  .nav {
    flex: 1;
    margin-left: 20px;
    min-width: 0;

    .top_nav {
      display: flex;
      flex-wrap: nowrap;
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        position: relative;
        margin-right: 5px;
        white-space: nowrap;

        a {
          display: block;
          padding: 10px 12px;
          color: #333;
          text-decoration: none;
          font-size: 16px;
          white-space: nowrap;
          transition: color 0.3s;

          &:hover {
            color: #1a73e8;
          }
        }

        &.on > a {
          color: #1a73e8;
          font-weight: bold;
        }

        &.has-sub:hover .sj_xia {
          display: block;
        }

        .sj_xia {
          display: none;
          position: absolute;
          top: 100%;
          left: 0;
          background: #fff;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          border-radius: 4px;
          list-style: none;
          padding: 8px 0;
          min-width: 120px;
          z-index: 100;

          li a {
            padding: 8px 20px;
            font-size: 15px;
            white-space: nowrap;

            &:hover {
              background: #f5f7fa;
            }
          }
        }
      }
    }
  }

  .search {
    display: flex;
    align-items: center;
    margin-left: 15px;
    flex-shrink: 0;

    .search_input {
      width: 150px;

      ::v-deep .el-input__inner {
        height: 38px;
        line-height: 38px;
        padding-left: 34px;
        border-radius: 19px 0 0 19px;
        border-right: none;
        background: #f5f7fa;
        border-color: #e4e7ed;
        transition: background 0.2s, border-color 0.2s;
      }

      ::v-deep .el-input__prefix {
        left: 12px;
        display: flex;
        align-items: center;
        color: #909399;
      }

      &:hover ::v-deep .el-input__inner {
        background: #fff;
        border-color: #c0c4cc;
      }
    }

    .search_btn {
      height: 38px;
      padding: 0 18px;
      border-radius: 0 19px 19px 0;
      font-size: 15px;
    }
  }

  .dl_zc {
    flex-shrink: 0;
    margin-left: 15px;
    font-size: 15px;

    a {
      color: #333;
      cursor: pointer;
      text-decoration: none;

      &:hover {
        color: #1a73e8;
      }
    }

    .divider {
      margin: 0 6px;
      color: #ccc;
    }

    .user-link {
      cursor: pointer;
      display: flex;
      align-items: center;

      .user-avatar {
        flex-shrink: 0;
        margin-right: 8px;
      }

      .user-name {
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .msg-badge {
        margin-left: 6px;
      }
    }
  }
}

/* 移动端导航 */
.mobile-header {
  display: none;
  background: #fff;
  padding: 10px 15px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  .xin_logo {
    img {
      height: 35px;
    }
  }

  .nav-btn {
    position: absolute;
    right: 15px;
    top: 15px;
    cursor: pointer;

    span {
      display: block;
      width: 24px;
      height: 2px;
      background: #333;
      margin: 5px 0;
      transition: all 0.3s;
    }

    &.active {
      span:nth-child(1) {
        transform: rotate(45deg) translate(5px, 5px);
      }
      span:nth-child(2) {
        opacity: 0;
      }
      span:nth-child(3) {
        transform: rotate(-45deg) translate(5px, -5px);
      }
    }
  }

  .mobile-nav {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    max-height: 70vh;
    overflow-y: auto;

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        border-bottom: 1px solid #f0f0f0;

        a {
          display: block;
          padding: 12px 20px;
          color: #333;
          text-decoration: none;
          font-size: 16px;
        }

        i {
          float: right;
          padding: 12px 20px;
          cursor: pointer;
        }

        .sub-nav {
          background: #f9f9f9;

          a {
            padding-left: 40px;
            font-size: 15px;
            color: #666;
          }
        }
      }
    }
  }
}

.clear {
  clear: both;
}

/* 中大宽屏：容器未拉满时适当压缩，避免导航与搜索区拥挤 */
@media (min-width: 1280px) and (max-width: 1600px) {
  .pc-header {
    .logo_box {
      padding: 0 10px;
    }
    .logo img {
      width: 200px;
      height: 56px;
    }
    .nav {
      margin-left: 10px;

      .top_nav li {
        margin-right: 1px;

        a {
          padding: 10px 7px;
          font-size: 14px;
        }
      }
    }
    .search {
      margin-left: 8px;

      .search_input {
        width: 140px;
      }
    }
    .dl_zc {
      margin-left: 8px;
      font-size: 14px;

      .user-link .user-name {
        max-width: 80px;
      }
    }
  }
}

/* 响应式：宽度不够时切换为移动端汉堡菜单 */
@media (max-width: 1279px) {
  .pc-header {
    display: none;
  }
  .mobile-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
